/**
 * @category Helper functions
 */
export var getCookie = function (cookieName, doc) {
    if (doc === void 0) { doc = document; }
    var parts = "; ".concat(doc.cookie).split("; ".concat(cookieName, "="));
    if (parts.length === 2) {
        return decodeURIComponent(parts[1].split(';')[0]);
    }
    return null;
};
//# sourceMappingURL=getCookie.js.map